"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomFieldTypeEnum = void 0;
var CustomFieldTypeEnum;
(function (CustomFieldTypeEnum) {
    CustomFieldTypeEnum["Text"] = "Text";
    CustomFieldTypeEnum["Number"] = "Number";
    CustomFieldTypeEnum["Address"] = "Address";
    CustomFieldTypeEnum["Dropdown"] = "Dropdown";
})(CustomFieldTypeEnum = exports.CustomFieldTypeEnum || (exports.CustomFieldTypeEnum = {}));
//# sourceMappingURL=CustomFieldTypeEnum.js.map